import React from "react";

const PdfIcon = ({ width = 20, height = 20 }) => {
  return (
    <svg
      id="pdf-svgrepo-com"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 19.463 23.634"
    >
      <path
        id="Path_17734"
        data-name="Path 17734"
        d="M181.5.034V6.985h6.951V23.668H168.99V.034Zm-3.508,8.341a.673.673,0,0,0-.528.259c-.613.738-.387,2.376-.231,3.349a1.11,1.11,0,0,1-.089.646L175.819,15.5a1.069,1.069,0,0,1-.45.487c-.838.466-2.244,1.1-2.413,2.248a1.081,1.081,0,0,0,.352.983A.984.984,0,0,0,174,19.5c1,0,1.635-.883,2.318-1.828a1.851,1.851,0,0,1,1.261-.749,25.95,25.95,0,0,0,2.747-.578,1.836,1.836,0,0,1,1.032.039,3.89,3.89,0,0,0,1.511.309,1.5,1.5,0,0,0,1.25-.424.9.9,0,0,0,.125-.808c-.146-.527-.025-1.1-1.638-1.1a7.493,7.493,0,0,0-1.007.075,1.307,1.307,0,0,1-1.194-.5c-.4-.5-.8-1.089-1.083-1.517a1.392,1.392,0,0,1-.2-1.023,3.089,3.089,0,0,0-.289-2.544,1,1,0,0,0-.837-.466Zm4.9-8.134,5.354,5.354h-5.354V.241Z"
        transform="translate(-168.99 -0.034)"
        fill="#0088e4"
        fillRule="evenodd"
      />
      <path
        id="Path_17735"
        data-name="Path 17735"
        d="M791.057,1021.07a14.7,14.7,0,0,1,3.4-.8,9.172,9.172,0,0,1-1.8-2.647,21.824,21.824,0,0,1-1.6,3.451"
        transform="translate(-783.4 -1005.094)"
        fill="#0088e4"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default PdfIcon;



// WEBPACK FOOTER //
// ./src/assets/PdfIcon.jsx